import React from "react"
import LandmarkSettingsView from '../landmarkSettingsView'

const LandmarkSettings = (props) => {

    const { mapRef } = props;
    return (
        <div>
            <LandmarkSettingsView mapRef={mapRef} />
        </div>
    )
}

export default LandmarkSettings

